//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState} from 'vuex';

export default {
  data: () => ({
    closed: false,
  }),
  computed: {
    ...mapState({
      settings: state => state.settings,
    }),
  },
};
